module.exports = __webpack_public_path__ + "img/lock.3c086b32.svg";